<template>
  <div>
    <div class="body">
      <div class="search">
        <div class="item">
          <el-input v-model="datas.user_id" placeholder="客户ID" clearable></el-input>
        </div>
        <div class="item">
          <el-input v-model="datas.keyword" :placeholder="$t('message.FuzzySearchHistoricalRecords')"
            clearable></el-input>
        </div>
        <!-- 开始日期-->
        <div class="item">
          <el-date-picker v-model="datas.datetimeStart" :placeholder="$t('message.startDate')" class="Container"
            type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!--  结束日期-->
        <div class="item">
          <el-date-picker v-model="datas.datetimeEnd" :placeholder="$t('message.dateClosed')" class="Container"
            default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <div class="item">
          <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
          <el-button @click="reset">{{ $t('message.reset') }}</el-button>

        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 发送对象 -->
          <el-table-column align="center" :label="$t('message.sendTo')" prop="send_realname" width="150">
          </el-table-column>
          <!-- 发送时间 -->
          <el-table-column align="center" :label="$t('message.sendingTime')" prop="send_time" width="150">
          </el-table-column>
          <!-- 聊天内容 -->
          <el-table-column align="center" :label="$t('message.chatContent')" prop="realname">
            <template slot-scope="scope">
              <div v-html="scope.row.body" @dblclick="getComplainMessageContext(scope.row.id, 'CW', scope.row.bodyCopy)"
                class="text-left">
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[200, 300, 500, 800]" :page-size="datas.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 上下50条 -->
    <upAndDown ref="upAndDown" />
  </div>
</template>
<script>
import upAndDown from './upAndDown.vue'
export default {
  components: {
    upAndDown,
  },
  props: {
    id: { type: Number }
  },
  data() {
    return {
      datas: {
        user_id: '',
        keyword: '',
        datetimeStart: '',
        datetimeEnd: '',
        page: 1,
        pageSize: 200,
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      upAndDownList: [],
    };
  },
  created() {
    // this.cwMessageList()
  },
  methods: {
    cwMessageList() {
      this.$api.siteConfiguration.cwMessageList(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.bodyCopy = JSON.parse(JSON.stringify(item.body))
          item.body = item.body.replaceAll('\n', '<br/>')
          if (this.datas.keyword) {
            item.body = item.body.replaceAll(this.datas.keyword, `<span style="color:#b4272d">${this.datas.keyword} </span>`)
          }
        })
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    search() {
      this.datas.page = 1
      this.cwMessageList()
    },
    //
    reset() {
      this.datas = {
        user_id: '',
        keyword: '',
        datetimeStart: '',
        datetimeEnd: '',
        page: 1,
        pageSize: 200,
      }
      this.cwMessageList()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.cwMessageList()
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.cwMessageList()
    },
    // RC聊天上下50条上下文
    getComplainMessageContext(id, chat_type, text) {
      this.$api.siteConfiguration.getCWComplainMessageContext({ id }).then(res => {
        res.data.forEach(item => {
          item.bodyCopy = JSON.parse(JSON.stringify(item.body))
          item.body = item.body.replaceAll('\n', '<br/>')
        })
        this.$refs.upAndDown.upAndDownList = res.data
        this.$refs.upAndDown.dialogVisible = true
        this.$refs.upAndDown.type = chat_type
        this.$refs.upAndDown.text = text
      })

    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;

  .item {
    margin-right: 24px;

  }

  .title {
    line-height: 40px;
    margin: 0 48px;
  }
}

.table {
  margin: 24px 0;


}

.text-left {
  text-align: left
}
</style>